// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._18u01wug{margin-left:auto}\n._19pkidpf{margin-top:0}\n._1bsb16xz{width:6pc}\n._1e0c1ule{display:block}\n._2hwx1wug{margin-right:auto}\n._4t3i16xz{height:6pc}\n._otyrpxbi{margin-bottom:var(--ds-space-200,1pc)}", ""]);
// Exports
module.exports = exports;
